<template>
  <div class="pdf-order-section">
    <div class="vz-personal-order-blocks">
      <div>
        <div class="text-h1 color-light">
          Плательщик
        </div>

        <div class="p-0 vz-position-relative">
          <div v-if="orderLockState.payer && !isCloned" class="disabled-card"/>
          <vz-switcher
            v-model="payer"
            class="text-caption vz-order-payer-switcher my-20"
            big
            :disabled="orderLockState.payer && !isCloned"
            :items="payers"
          />
        </div>
      </div>

      <div
        v-if="hasProject"
        class="p-0 vz-position-relative"
      >
        <div v-if="orderLockState.payer && !isCloned" class="disabled-card"/>
        <vz-order-payer-project
          v-model:isProject="isProject"
          :direction="payer"
          :disabled="orderLockState.payer && !isCloned"
        />
      </div>
    </div>

    <vz-col v-if="isSegregated && !orderLockState.payer" col="12" class="p-0">
      <vz-order-payer-segregated v-show="isDesktop"/>
      <vz-order-payer-segregated-mini v-show="!isDesktop"/>
    </vz-col>
  </div>
</template>

<script setup lang="ts">
import $breakpoints from '~/composables/breakpoints';
import VzOrderPayerSegregated from '~/components/personal/order/payer/vz-order-payer-segregated.vue';
import VzOrderPayerSegregatedMini from '~/components/personal/order/payer/vz-order-payer-segregated-mini.vue';
import useOrderPayer from '~/components/personal/order/payer/useOrderPayer';
import VzCol from "~/components/ui-kit/vz-col.vue";
import VzSwitcher from "~/components/ui-kit/vz-switcher.vue";
import VzOrderPayerProject from "~/components/personal/order/payer/vz-order-payer-project.vue";
import {storeToRefs} from "pinia";
import {useUserStore} from "~/stores/personal/user";
import {useOrderProjects} from "~/stores/personal/order-projects";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  },
  hideSegregate: {
    type: Boolean,
    default: false
  },
  hideProject: {
    type: Boolean,
    default: false
  },
})

const {orderLockState, isSegregated, isCloned, payer} = useOrderPayer()
const {isAuth} = storeToRefs(useUserStore())
await useOrderProjects().receiveProjects();
const {projectsList} = useOrderProjects();

const isProject = ref(false);

const payers = computed(() => {
  let result = [
    {
      title: 'Отправитель',
      value: 'dispatch'
    },
    {
      title: 'Получатель',
      value: 'destination'
    },
    {
      title: 'Третье лицо',
      value: 'third'
    },
    {
      title: 'Разделить',
      value: 'segregated',
      disabled: isProject.value,
      disabledText: 'Нельзя разделить когда выбран проект'
    }
  ]

  if (props.hideSegregate) {
    result = result.filter(item => item.value !== 'segregated')
  }

  return result
})

const isDesktop = computed(() => {
  return $breakpoints.width > 1024
})

const hasProject = computed(() => {
  return !props.hideProject && isAuth.value && projectsList.length && !isSegregated.value
})
</script>

<style lang="scss" scoped>
.vz-order-payer-switcher {
  min-height: 46px;

  :deep(.vz-switcher-item) {
    padding: 10px !important;
  }
}
</style>
